import { useEffect, useRef } from 'react';
import { useIntersection } from 'react-use';
import useTracker from './useTracker';

const useImpression = (profileId, blockId, itemId, linkId) => {
  const ref = useRef()
  const intersection = useIntersection(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });
  const saved = useRef()
  const track = useTracker('impression')
  useEffect(() => {
    if (intersection && !saved.current && intersection.intersectionRatio > 0) {
      // console.log(blockId, itemId, linkId, intersection.intersectionRatio)
      if (typeof profileId === 'function') {
        saved.current = profileId(ref.current)
      } else {
        saved.current = track(profileId, blockId, itemId, linkId)
      }
    }
  }, [profileId, blockId, itemId, linkId, intersection, track])
  return ref
};

export default useImpression;
